<template>
  <div>
    <v-file-input
      ref="fileInput"
      :model-value="null"
      v-bind="$attrs"
      :placeholder="$attrs.label"
      :hint="$attrs.hint"
      multiple
      persistent-hint
      :accept="accept"
      :clearable="false"
      chips
      variant="outlined"
      @update:model-value="selectedFile($event)"
    />
    <div v-for="(doc, i) in uploadedFiles" :key="doc.id" class="mb-2">
      <v-file-input
        v-model="uploadedFiles[i]"
        persistent-hint
        hide-details
        chips
        density="compact"
        small-chips
        :full-width="false"
        variant="outlined"
        @click:clear="remove(i)"
      />
    </div>
  </div>
</template>
<script>
export default {
  name: "AppFileUploadMultiple",
  props: {
    modelValue: { type: Array, default: () => [] },
    accept: { type: String, default: null },
    doNotShowUploaded: { type: Boolean, default: false }
  },
  emits: ["update:modelValue"],
  computed: {
    uploadedFiles: {
      get() {
        return this.modelValue.reduce((arr, doc) => {
          if (!doc.id) arr.push(doc);
          else if (!this.doNotShowUploaded) {
            arr.push(new File([doc.path], doc.filename ?? ""));
          }
          return arr;
        }, []);
      },
      set(v) {
        this.selectedFile(v);
      }
    }
  },
  methods: {
    selectedFile(val) {
      if (!val) return;

      let intervalValue = this.modelValue;
      if (Array.isArray(val)) intervalValue = intervalValue.concat(val);
      else intervalValue.push(val);

      this.$emit(
        "update:modelValue",
        intervalValue.filter(x => x)
      );
      // Component still keeps selected files regardless parent changing value to null
      this.$refs.fileInput.lazyValue = null;
      this.$refs.fileInput.initialValue = null;
      // Element's value also needs to be flushed
      const el = this.$el.querySelector("input[type=file]");
      el.value = null;
      //this.$refs.fileInput.blur();
    },
    remove(index) {
      let uploadedFiles = this.uploadedFiles;
      uploadedFiles.splice(index, 1);
      this.$emit(
        "update:modelValue",
        uploadedFiles.filter(x => x)
      );
    }
  }
};
</script>
